import { render, staticRenderFns } from "./InsuranceModal.vue?vue&type=template&id=05673102"
import script from "./InsuranceModal.vue?vue&type=script&lang=js"
export * from "./InsuranceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports